// Native & external imports
import { Component, Input, Output, EventEmitter, inject } from "@angular/core";
// Objects
import { CmpAlertModalObject } from "src/objects/cmp-alert.object";
// Services
import { LayoutService } from "src/services/layout.service";

@Component({
  standalone: false,
  selector: "cmp-alert",
  templateUrl: "./alert.component.html",
})
export class AlertComponent {
  layoutService = inject(LayoutService);

  @Input() alertModalObject = new CmpAlertModalObject();
  @Output() emitResponse = new EventEmitter();

  /**
   * @method closePopup
   * @param from string
   * @description Return action value to close the current popup & trigger required action
   * @returns void
   */
  public closePopup(value = "") {
    this.layoutService.emitConfirmModalResponse.next();
    this.emitResponse.emit({
      from: "alertModal",
      value,
    });
  }
}
